import { Box } from "@mui/material";
import { style } from "./table.style";
export const TableHead = ({ children, blocked }) => (
  <Box component="thead" sx={blocked ? [style.tableHead, { pointerEvents: "none" }] : style.tableHead} className="table__head">{children}</Box>
);
